module.exports = __webpack_public_path__ + "img/電気回路_1_8_1.ace843c1.png";